"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliceContent = exports.SliceLegacy = void 0;
const tslib_1 = require("tslib");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const CompositeSliceContent_1 = require("./CompositeSliceContent");
const SharedSliceContent_1 = require("./SharedSliceContent");
const SimpleSliceContent_1 = require("./SimpleSliceContent");
const SliceLegacy = (ctx) => {
    return {
        decode: (value) => {
            const codec = (() => {
                switch (ctx.fieldType) {
                    case "Slice":
                        return (0, CompositeSliceContent_1.CompositeSliceLegacy)(ctx);
                    case "SharedSlice":
                        return (0, SharedSliceContent_1.SharedSliceLegacy)(ctx);
                    default:
                        return (0, SimpleSliceContent_1.SimpleSliceLegacy)(ctx);
                }
            })();
            return codec.decode(value);
        },
        encode: (value) => {
            switch (value.__TYPE__) {
                case "SharedSliceContent":
                    return (0, SharedSliceContent_1.SharedSliceLegacy)(ctx).encode(value);
                case "CompositeSliceContent":
                    return (0, CompositeSliceContent_1.CompositeSliceLegacy)(ctx).encode(value);
                default:
                    return (0, SimpleSliceContent_1.SimpleSliceLegacy)(ctx).encode(value);
            }
        },
    };
};
exports.SliceLegacy = SliceLegacy;
exports.SliceContent = t.union([
    CompositeSliceContent_1.CompositeSliceContent,
    SharedSliceContent_1.SharedSliceContent,
    SimpleSliceContent_1.SimpleSliceContent,
]);
(0, tslib_1.__exportStar)(require("./CompositeSliceContent"), exports);
(0, tslib_1.__exportStar)(require("./SharedSliceContent"), exports);
(0, tslib_1.__exportStar)(require("./SimpleSliceContent"), exports);
